import { fetchWithAuth } from "./utils/ApiUtils";
import { config } from "./Constants";

const URL = config.url;
const BASE_URL = `${URL}/api/v1/tracking`;

export const TrackingService = {
    getUserTrackedStocks: async () => {
        try {
            const response = await fetchWithAuth(BASE_URL);
            if (!response.ok) {
                throw new Error('Failed to fetch tracked stocks');
            }
            const data = await response.json();
            return data.data || [];
        } catch (error) {
            console.error('Error fetching tracked stocks:', error);
            throw error;
        }
    },

    createTracking: async (stockSku) => {
        try {
            const response = await fetchWithAuth(`${BASE_URL}/${stockSku}`, {
                method: 'POST'
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to create tracking');
            }

            const data = await response.json();
            return data.data;
        } catch (error) {
            console.error('Error creating tracking:', error);
            throw error;
        }
    },

    createBulkTracking: async (skus) => {
        try {
            const response = await fetchWithAuth(`${BASE_URL}/bulk`, {
                method: 'POST',
                body: JSON.stringify(skus)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to track GPUs');
            }

            const data = await response.json();
            return data.data;
        } catch (error) {
            console.error('Error with bulk tracking:', error);
            throw error;
        }
    },

    removeTracking: async (stockSku) => {
        try {
            const response = await fetchWithAuth(`${BASE_URL}/${stockSku}`, {
                method: 'DELETE'
            });

            if (!response.ok) {
                throw new Error('Failed to remove tracking');
            }

            return true;
        } catch (error) {
            console.error('Error removing tracking:', error);
            throw error;
        }
    },

    removeBulkTracking: async (skus) => {
        try {
            const response = await fetchWithAuth(`${BASE_URL}/bulk`, {
                method: 'DELETE',
                body: JSON.stringify(skus)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to untrack GPUs');
            }

            const data = await response.json();
            return data.data;
        } catch (error) {
            console.error('Error with bulk untracking:', error);
            throw error;
        }
    },

    isStockTracked: async (stockSku) => {
        try {
            const response = await fetchWithAuth(`${BASE_URL}/${stockSku}/status`);

            if (!response.ok) {
                throw new Error('Failed to check tracking status');
            }

            const data = await response.json();
            return data.data || false;
        } catch (error) {
            console.error('Error checking if stock is tracked:', error);
            return false;
        }
    },

    // "Only email me at or under this price" (#357). null clears the cap.
    updateMaxAlertPrice: async (stockSku, maxPrice) => {
        const hasPrice = maxPrice !== null && maxPrice !== undefined && maxPrice !== '';
        const url = hasPrice
            ? `${BASE_URL}/${stockSku}/max-price?maxPrice=${encodeURIComponent(maxPrice)}`
            : `${BASE_URL}/${stockSku}/max-price`;

        const response = await fetchWithAuth(url, { method: 'PUT' });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || 'Failed to update the maximum price');
        }

        const data = await response.json();
        return data.data;
    },

    updateNotificationPreferences: async (stockSku, emailInStoreNotifications, emailOnlineNotifications) => {
        try {
            let url = `${BASE_URL}/${stockSku}/preferences?`;
            
            if (emailInStoreNotifications !== undefined) {
                url += `emailInStoreNotifications=${emailInStoreNotifications}&`;
            }
            
            if (emailOnlineNotifications !== undefined) {
                url += `emailOnlineNotifications=${emailOnlineNotifications}&`;
            }
            
            url = url.replace(/[&?]$/, '');

            const response = await fetchWithAuth(url, {
                method: 'PUT'
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to update notification preferences');
            }

            const data = await response.json();
            return data.data;
        } catch (error) {
            console.error('Error updating notification preferences:', error);
            throw error;
        }
    }
};